<template>
  <div class="vehicle-map-info-card">
    <div v-for="row in rows" :key="row.key" class="vehicle-map-info-card__row">
      <span class="vehicle-map-info-card__label">{{ row.label }}</span>
      <span class="vehicle-map-info-card__value">{{ row.value }}</span>
    </div>
  </div>
</template>

<script>
import { formatBatteryTempDisplay } from '@/utils/batteryTempDisplay.js'

export default {
  name: 'VehicleMapInfoCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rows () {
      const item = this.item || {}
      const lockLabels = [this.$t('home.name28'), this.$t('home.name29')]
      const statusLabels = [this.$t('bike.name113'), this.$t('bike.name228'), this.$t('home.name30')]
      const speed = item.speed === '--'
        ? '--'
        : Number(item.speed / 10).toFixed(1)
      const batteryTemp = formatBatteryTempDisplay(item.batteryTemp, item.batteryTemperatureShowDeviation)
      // 高温预警接口为 keepaliveTime；整车详情等接口历史字段为 keepliveTime
      const keepaliveTime = item.keepaliveTime || item.keepliveTime || '--'

      return [
        { key: 'ebikeId', label: this.$t('bike.name65'), value: item.ebikeId || '--' },
        { key: 'ebikeCode', label: this.$t('bike.name295'), value: item.ebikeCode || '--' },
        { key: 'mac', label: this.$t('bike.name492'), value: item.mac || '--' },
        { key: 'tenantName', label: this.$t('bike.name493'), value: item.tenantName || '--' },
        { key: 'keepaliveTime', label: this.$t('bike.name168'), value: keepaliveTime },
        { key: 'alt', label: this.$t('bike.name171'), value: item.alt || '--' },
        { key: 'speed', label: this.$t('bike.name216'), value: speed },
        { key: 'soc', label: this.$t('bike.name217'), value: item.soc || '--' },
        { key: 'lockStatus', label: this.$t('bike.name494'), value: lockLabels[item.lockStatus] || '--' },
        { key: 'status', label: this.$t('bike.name35'), value: statusLabels[item.status] || '--' },
        { key: 'batteryTemp', label: this.$t('bike.name220'), value: batteryTemp },
      ]
    },
  },
}
</script>

<style lang="scss">
.vehicle-map-info-card {
  font-size: 12px;
  line-height: 1.6;
  min-width: 240px;
  color: #333;

  &__row + &__row {
    margin-top: 2px;
  }

  &__label {
    color: #666;
  }

  &__value {
    word-break: break-all;
  }
}
</style>
